// Keeps the free mystery sample in step with the cart: the drawer partial renders this
// element only when the gift must be added, removed or reset to one; it acts once.
class SGiftRule extends HTMLElement {
  async connectedCallback() {
    if (this.dataset.done) return;
    this.dataset.done = 'true';
    const actions = window.Shopify?.actions;
    if (!actions?.updateCart) return;
    const { action, variantId, lineKey, label } = this.dataset;
    let lines = null;
    if (action === 'add') {
      lines = [{ merchandiseId: variantId, quantity: 1, attributes: [{ key: '_gift', value: 'mystery' }, { key: 'Inhalt', value: label || '' }] }];
    } else if (action === 'remove' && lineKey) {
      lines = [{ id: lineKey, quantity: 0 }];
    } else if (action === 'single' && lineKey) {
      lines = [{ id: lineKey, quantity: 1 }];
    }
    if (!lines) return;
    try {
      // The product context keeps a failed gift update (e.g. sold out) from raising an error toast.
      await actions.updateCart({ lines }, { event: { context: 'product', detail: { source: 's-gift-rule' } } });
    } catch {
      // The cart stays usable without the gift; nothing to surface to the shopper.
    }
  }
}

customElements.get('s-gift-rule') || customElements.define('s-gift-rule', SGiftRule);
